import { STORE_COMMIT } from "../store/store"



export const logMixin = {

	computed: {


		unReadWarningCount() {
			return this.$store.state.eventList.filter(event => !event.read && event.type == "WARNING").length
		},
		unReadErrorCount() {
			return this.$store.state.eventList.filter(event => !event.read && event.type == "ERROR").length
		}
	},

	methods: {


		appendLog(status, message) {

			const event = { status: status, message: message }
			this.$store.commit(STORE_COMMIT.APPEND_EVENT_LOG, event, { root: true });

			setTimeout(() => {
				this.$store.commit(STORE_COMMIT.DISPLAYED_EVENT, event.id, { root: true })
			}, 1000)
		},

		logOK(message) {
			this.appendLog("OK", message);
		},

		logInfo(message) {
			this.appendLog(this.createEvent(message, "INFO"));
		},

		logWarning(message) {
			this.appendLog("WARNING", message);

		},

		logError(message) {
			this.appendLog("ERROR", message);
			//this.appendLog(this.createEvent(message, "ERROR"));
		},

		logDebug(message) {
			this.appendLog("DEBUG", message);
		},




		/*setAllRead() {

			this.$store.commit("setAllRead");

		},

		setEventRead(eventId) {

			this.$store.commit("setEventRead", eventId);

		},
		emptyLog() {
			if (window.confirm("Radera alla?")) {
				this.$store.commit("emptyLog");
			}
		},*/
		debugClientMessage(message) {
			message = message + "\n--------------\n" +
				navigator.appName + "\n" +
				navigator.userAgent + "\n" +
				window.location.href.toString()

			navigator.clipboard.writeText(message);
			alert(message);
		},

		logAlert(message) {
			alert(message);
		},





	}
}



